"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const CrossInCircleSystemIcon = props => {
  const {
      size = 24
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "CROSS-IN-CIRCLE-SYSTEM-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M12.008.022c6.602 0 11.953 5.352 11.953 11.953 0 6.602-5.351 11.954-11.953 11.954-6.602 0-11.953-5.352-11.953-11.954C.055 5.374 5.406.022 12.008.022Zm0 1.5c-5.773 0-10.453 4.68-10.453 10.453 0 5.774 4.68 10.454 10.453 10.454s10.453-4.68 10.453-10.454c0-5.773-4.68-10.453-10.453-10.453ZM6.995 6.964a.75.75 0 0 1 1.061 0l3.95 3.95 3.952-3.95a.75.75 0 0 1 .976-.073l.085.073a.75.75 0 0 1 0 1.06l-3.951 3.951 3.952 3.951a.75.75 0 0 1 .072.977l-.072.084a.75.75 0 0 1-1.061 0l-3.952-3.952-3.95 3.952a.75.75 0 0 1-.976.073l-.085-.073a.75.75 0 0 1 0-1.06l3.95-3.952-3.95-3.95a.75.75 0 0 1-.073-.977Z"
  })));
};
CrossInCircleSystemIcon.displayName = "CrossInCircleSystemIcon";
CrossInCircleSystemIcon.iconName = "CrossInCircle";
export default CrossInCircleSystemIcon;